import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { EuiFieldText, EuiForm, EuiFormRow, EuiSpacer, EuiText, EuiTitle } from '@elastic/eui'

import { RootState } from 'app/rootReducer'
import { setUrl } from 'features/planner/CreateMasterCampaignPlanSlice'

import { Account } from '../../api/interfaces'
import { updateAccountState } from '../../app/appSlice'
import { ClientPicker } from '../../components/account/ClientPicker'
import { isValidURL } from '../../utils/isValidUrl'

export const EnterUrlStep = () => {
  const dispatch = useDispatch()
  const { url } = useSelector((state: RootState) => state.createMasterCampaignPlan)
  const { currentAccount } = useSelector((state: RootState) => state.app)

  const onClientChange = (selectedClient: Account) => {
    dispatch(updateAccountState(selectedClient))
  }

  return (
    <>
      <EuiTitle size={'s'}>
        <h2>Step 1: Verify Website URL</h2>
      </EuiTitle>
      <EuiText>AdCritter AI uses the website to perform market research for the master campaign plan.</EuiText>
      <EuiSpacer />
      <EuiForm>
        <EuiFormRow label='Client'>
          <ClientPicker selectedClient={currentAccount ?? undefined} onClientChange={onClientChange} />
        </EuiFormRow>
        <EuiFormRow isInvalid={!isValidURL(url)} error={<EuiText size={'xs'}>Ensure URL begins with https://</EuiText>} label={'Website URL'} helpText={'Enter a valid URL in the format: https://adcritter.com. If client has multiple sites, use the website this campaign plan should be based on.'}>
          <EuiFieldText value={url} onChange={e => dispatch(setUrl(e.target.value))} />
        </EuiFormRow>
      </EuiForm>
    </>
  )
}
